<template>
  <header class="header">
    <div
      v-if="hiddenSelectCountries"
      class="header__countries"
    >
      <CountryListSelect />
    </div>
    <div
      v-if="hiddenSeparator"
      class="header__vl"
    />
    <div
      class="header__request"
      @click="showPurchaseSummary()"
    >
      <AmIconMaterial
        :class="['header__request__cart', `text--${theme.color}`]"
        name="shopping_cart"
        size="sm"
      />
      <AmTypography
        :class="['header__request__see', `text--${theme.color}`]"
        :text="$t('containerRigth.requests.seeRequest')"
        typography-style="l-menu"
      />
      <AmSkeleton
        v-if="loadingCart"
        class="header__skeleton"
        AmType="text"
        AmTextWidth="40"
        AmTextBorder
        AmTextHeight="sm"
        :AmTextGroupLimit="3"
      />
      <AmTypography
        v-else
        :class="['header__request__see', `text--${theme.color}`]"
        :text="$t('containerRigth.requests.productTotal', { total: totalCartFormat })"
        typography-style="l-menu"
      />
      <AmIconMaterial
        :class="`header__request__expand text--${theme.color}`"
        name="expand_more"
        size="sm"
        color="#0083f3"
      />
    </div>
  </header>
</template>

<script>
import themeMixin from '@/components/mixins/themeMixin'
import currencyFilterMixin from '@/components/mixins/currencyFilterMixin'
import { mapState, mapGetters } from 'vuex'
import CountryListSelect from '../CountryListSelect/CountryListSelect.vue'

export default {
  name: 'CheckoutHeader',
  components: {
    CountryListSelect,
  },
  mixins: [themeMixin, currencyFilterMixin],
  computed: {
    ...mapState('Checkout', {
      loadingCart: (state) => state.cartLoading,
    }),
    ...mapGetters('Cart', [
      'isInfoProduto',
      'getCurrencyCode',
      'getEnableInternational',
      'getSelectedInstallment',
      'getTotal',
    ]),
    totalCartFormat() {
      return this.$options.filters.currency(this.total, { codeCurrency: this.getCurrencyCode })
    },
    total() {
      return this.getSelectedInstallment && Object.keys(this.getSelectedInstallment).length
        ? this.getSelectedInstallment.total
        : this.getTotal
    },
    hiddenSelectCountries() {
      const app_show = process.env.VUE_APP_SHOW_SELECT_COUNTRIES.replace(/"/g, '') === 'true'
      return app_show && this.isInfoProduto && this.getEnableInternational
    },
    hiddenSeparator() {
      return this.$mq !== 'desktop' && this.hiddenSelectCountries
    },
  },
  methods: {
    showPurchaseSummary() {
      this.$emit('showPurchaseSummary')
    },
  },
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  height: 70px;
  background: $white;
  position: absolute;
  box-shadow: 0 5px 6px -6px $dark;
  z-index: 4;

  &__countries {
    margin-left: auto;
    @include desktop {
      margin-right: 24px;
    }
  }

  &__vl {
    width: 1px;
    height: 13px;
    background-color: $light-40;
    margin: 0 12px 0 8px;
  }

  @include mobile {
    width: 100%;
    box-shadow: none;

    &__logo {
      display: flex;
      margin: 0 0 0 20px;

      img {
        width: 150px;
      }
    }
  }

  @include tablet {
    &__logo {
      display: flex;
      margin: 0 0 0 20px;

      img {
        width: 200px;
      }
    }
  }

  @include desktop {
    &__logo {
      display: flex;
      margin: 0 0 0 50px;

      img {
        width: 200px;
      }
    }
  }

  &__skeleton {
    width: 65px;
    ::v-deep {
      .b-skeleton {
        background-color: $light-80 !important;
      }
      .b-skeleton-animate-wave::after {
        background: linear-gradient(90deg, transparent, $white, transparent);
      }
    }
  }

  &__request {
    display: none;
    align-items: center;
    margin: 0 20px 0 0;

    @include mobile {
      display: flex;
    }

    @include tablet {
      display: flex;
    }

    &__cart {
      margin: 0 9px 0 0;
    }

    &__see {
      cursor: pointer;
      padding-right: 5px;
      ::v-deep {
        .l-menu {
          font-size: 14px;
        }
      }
    }
    &__expand {
      margin: 0 0 0 9px;
    }
  }
}
</style>
